import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';


@Injectable()
export class TarifNameService {

  constructor(
  				private http: HttpClient,
  				private global: GlobalDataService
  			  ) { }


   getTarifName(isActive:number=-1) {

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl+"tariff/names"+isAvailable)
   }

   getTarifNameByFilter(filter: any[]){
    let url = "";
    for (var item of filter) {
        url += item.name + "=" + item.value + "&";
    }
    url = url.substring(0,url.length-1);
    return this.http.get(this.global.httpUrl + "tariff/names?" + url);
}

   getTarifNameById(id: any) {
        return this.http.get(this.global.httpUrl+"tariff/names/"+id)
   } 
  

   createTarifName(data: any){
        return this.http.post(this.global.httpUrl+"tariff/names", data); 
   }

   updateTarifName(data: any,id: any){
        return this.http.put(this.global.httpUrl+"tariff/names/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/tarifs/tarif-name.service.ts